<div
  fxLayout="row"
  fxLayoutGap="16px"
  fxLayoutAlign="start center"
  class="u-marginBottom-16"
>
  <mat-icon class="md-18">email</mat-icon>
  <p class="text-subtitle-2" i18n="@@settingsView.emailChange.title">
    Change your email address
  </p>
</div>
<form>
  <div fxLayout="column">
    <label class="u-marginBottom-8" i18n="@@settingsView.emailChange.panelLabel"
      >Email<span *ngIf="!isEmailChangeEnabled">
        (Changing emails is disabled for this community)</span
      ></label
    >
    <input
      class="u-padding-16 u-marginBottom-16"
      [ngClass]="!isEmailChangeEnabled ? 'color-grey-300' : 'color-black'"
      nz-input
      [readonly]="!isEmailChangeEnabled"
      [formControl]="emailChangeForm"
    />
    <p
      *ngIf="account.pending_email"
      class="text-caption color-grey-300"
      i18n="@@settingsView.emailChange.pendingEmailChangeCaption"
    >
      Your verified email is
      <span class="color-blue">{{ account.email }}</span
      >. Please follow the link sent to
      <span class="color-blue">{{ account.pending_email }}</span> to change your
      email address (<span
        (click)="sendVerificationEmail(emailChangeForm)"
        class="color-blue u-textDecoration-underline"
        >Resend verification</span
      >).
    </p>
  </div>
  <div
    *ngIf="isEmailChangeEnabled"
    fxLayout="row"
    fxLayoutAlign="end center"
    class="u-marginTop-8"
  >
    <button
      *ngIf="!account.pending_email"
      mat-raised-button
      color="primary"
      type="button"
      [disabled]="isLoading"
      (click)="saveForm(emailChangeForm)"
      i18n="@@settingsView.emailChange.changeEmail"
    >
      Change email
    </button>
    <button
      *ngIf="account.pending_email"
      color="warn"
      mat-stroked-button
      type="button"
      [disabled]="isLoading"
      (click)="cancelEmailChange()"
      i18n="@@settingsView.emailChange.cancelEmailChange"
    >
      Cancel email change
    </button>
  </div>
</form>
